import React, { useEffect } from "react";
import Footer from "../Footer";
import Header from "../Header";

import "aos/dist/aos.css";
import AOS from "aos";

import WhatsApp from "../../assets/images/chat/whatsapp.webp";

const Layout = (props) => {
  const { children } = props;

  useEffect(() => {
    AOS.init({
      easing: "ease-in-out-back",
    });
  }, []);

  return (
    <div className="h-full min-h-screen w-full bg-background dark:bg-neutral-900 relative">
      <Header />
      {children}
      <Footer />
      <img
        onClick={() => window.open("https://wa.me/351963203174")}
        className="fixed bottom-5 right-8 sm:bottom-10 sm:right-10 w-[50px] cursor-pointer"
        src={WhatsApp}
        width="100%"
        alt="call-us"
      ></img>
    </div>
  );
};

export default Layout;
